import { Injectable } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';

@Injectable({ providedIn: 'root' })
export class ActiveCallsRegisterSessionStorageService {
   private readonly baseKey = '__ndt-activeCalls-ordering-options';

   private getStorageKey(register: ActiveCallRegisterType): string {
      return `${this.baseKey}:${register}`;
   }

   clearAll(): void {
      Object.keys(localStorage)
         .filter((key) => {
            return key.startsWith(this.baseKey);
         })
         .forEach((key) => localStorage.removeItem(key));
   }

   removeOrderingOptions(register: ActiveCallRegisterType): void {
      localStorage.removeItem(this.getStorageKey(register));
   }

   getOrderingOptions(register: ActiveCallRegisterType): OrderingOption[] | null {
      const localData = localStorage.getItem(this.getStorageKey(register));
      return localData ? JSON.parse(localData) : null;
   }

   setOrderingOptions(register: ActiveCallRegisterType, orderingOptions: OrderingOption[] | null): void {
      localStorage.setItem(this.getStorageKey(register), JSON.stringify(orderingOptions));
   }
}

export enum ActiveCallRegisterType {
   SystemActive = 'system-active',
   AccountActive = 'account-active',
   AccountHistory = 'account-history',
}
